<!-- This modal needs to '[closable]=false' to hide the built in 'X' icon that ngx comes with -->
<ng-template #template>
  <app-modal
    (close)="closeModal()"
    (submit)="submit()"
    (addAnother)="toggleAddAnother()"
    [header]="title"
    [submitLabel]="submitTitle"
    [submitting]="submitting"
    [openAnotherModalCheckbox]="openAnotherModalCheckbox"
    [editable]="editable"
    [showRibbon]="true">
    <div role="form">
      @if (formValidator && itemForm) {
<form

        [formGroup]="itemForm"
        (ngSubmit)="submit()"
        id="form-container">
        <!--  if sales exist (been sold) -->
        @if (editable && showInfoAlert) {
<div class="sale-item-form__alert">
          <se-fe-alert seFeDataType="info">
            Edits will affect future sales only
            <se-fe-alert-subheader>
              Changes won’t affect any sent invoices or previously-placed orders
            </se-fe-alert-subheader>
          </se-fe-alert>
        </div>
}

        @if (serverErrors.length) {
<div class="sale-item-form__alert">
          <se-fe-alert seFeDataType="error">
            Your sale item couldn't be {{ errorAction }}
          </se-fe-alert>
        </div>
}

        <div class="sale-item-form__field">
          <se-fe-form-field [seFeDataConfig]="nameFieldConfig">
            <se-fe-form-field-text
              formControlName="name"
              seFeDataAutoComplete="off"
              (blur)="trimName()"
              maxlength="64">
            </se-fe-form-field-text>
          </se-fe-form-field>
          <div class="sale-item-form__character-count">
            {{getTrimmedNameLength()}}/64 characters
          </div>
        </div>

        <app-payment-amount-options
          [itemForm]="itemForm"
          [itemVariation]="itemVariation"
          [formValidator]="formValidator"
          [showSaleItemType]="showSaleItemType"
          [showTaxCode]="showTaxCode">
        </app-payment-amount-options>
      </form>
}
    </div>
    <div role="ribbon-text">
      <app-payment-plan-text></app-payment-plan-text>
    </div>
  </app-modal>
</ng-template>
